import React from 'react';
import styled from 'styled-components';
import { Body7 } from '@ui';

// The pill every status in the feature is drawn with: a dot coloured from a theme token and a bold
// caption. Copied from scoreBackfill/StatusBadge.js; the token maps live in statusTokens.js so a
// pill and a dot for the same status cannot disagree.

const Pill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 10px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.themeColors.lowContrastBorder};
  background: ${({ theme }) => theme.themeColors.componentNoOpacity};
  white-space: nowrap;
`;

export const Dot = styled.span`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ theme, $token }) => theme.themeColors[$token] || theme.themeColors.secondaryText};

  ${({ $pulse }) =>
    $pulse &&
    `
    animation: fmdcStatusPulse 1.4s ease-in-out infinite;
  `}

  @keyframes fmdcStatusPulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.35;
    }
    100% {
      opacity: 1;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const StatusPill = ({ token, label, pulse = false, title }) => (
  <Pill title={title}>
    <Dot $token={token} $pulse={pulse} />
    <Body7 bold>{label}</Body7>
  </Pill>
);
